import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Button } from 'react-bootstrap';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DocumentView from 'components/sales/downloadDocView/documentView';
import moment from 'moment';
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import useLatLng from 'hooks/uselatlng/uselatlng';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import parse from 'html-react-parser';
import { calcCrow, formatDescription } from '../../../services/utils/helpers/customHelper';
import {shouldShowSiteCheckinModal, isActiveDistanceCheckin} from 'services/attendance/isActiveDistanceCheckin';
import {
  checkoutErrorMessage,
  getSiteLatLng,
  isCheckoutApiSuccess,
  resolveDistanceRowId,
} from 'services/attendance/siteCheckout';

const RmView = ({
  fetchRmTicketDetails,
  rmTicketDetails,
  postUpdateRMStatus,
  documentUploadUrl,
  postRmRemark,
  match,
  fetchRmTicketStatus,
  rmStatus,
  location,
  getSiteData,
  siteData,
  calculateDistance,
  engDistanceData,
  getDistanceData,
  distanceDetails,
  history,
  activeDistanceCheckin,
  refreshAfterSiteCheckout,
}) => {

  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [assigneeId, setAssigneeId] = useState('');
  const [isRoleId, setIsRoleId] = useState([]);
  const [remarkData, setRemarkData] = useState({
    rm_ticket_id: match.params.id,
    remarks: '',
    attachment: '',
    reason:''
  });
  const [successModal, setSuccessModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [siteId, setSiteId] = useState('');
  const [checkSiteIdSet, siteIdSetChecked] = useState(false)
  const [role, setRole] = useState('')
  const islatlng = useLatLng();
  const [distanceReady, setDistanceReady] = useState(false);

  // useEffect(() => {
  //   let roles = JSON.parse(localStorage.getItem('roles'))
  //   setRole(roles[0]?.id)
  //   setSiteId('')
  //   delete rmTicketDetails.complains?.site_id
  //   setIsOpen(!isOpen);
  // }, [])

  useEffect( () => {
    (async () => {
      if(rmTicketDetails !== null && rmTicketDetails.complains != null && Object.keys(rmTicketDetails.complains).length > 0){
        setIsLoading(true)
        const ticketSiteId = rmTicketDetails.complains['site_id'];
        if(ticketSiteId !== undefined){
          await getDistanceData(ticketSiteId, 'RM', match.params.id)
        }
        setSiteId(ticketSiteId)
        siteIdSetChecked(true)
        setDistanceReady(true)
        setIsLoading(false)
      }
    })()
  }, [rmTicketDetails])

  useEffect(() => {
    if (siteId && getSiteData) {
      getSiteData(siteId);
    }
  }, [siteId]);

  useEffect( () => {
    if (!distanceReady) return;
    setIsOpen(
      shouldShowSiteCheckinModal({
        distanceDetails,
        activeCheckin: activeDistanceCheckin,
        siteId,
        moduleType: 'RM',
      })
    );
  }, [distanceDetails, distanceReady, activeDistanceCheckin, siteId])

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles.map((obj) => isRoleId.push(obj.id));
        setIsRoleId(isRoleId);
      })();
    }, 0);
  }, [isRoleId]);

  useEffect( () => {
    if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
      toast.success('Distance is successfully fetched');
      setIsOpen(false);
      Object.keys(engDistanceData).forEach(key => {
        delete engDistanceData[key];
      })
    }else if(engDistanceData === null){
      toast.success('Distance is not fetched');
      setIsOpen(true);
    }
  }, [engDistanceData])

  const handleModalHide = () => setIsModal(false);

  const handleCheckOut = async (passedId) => {
    const id = passedId || resolveDistanceRowId(distanceDetails, activeDistanceCheckin);
    if (!id) {
      toast.error('Check-in record not found.');
      return false;
    }
    const checkout_lat = Number(islatlng?.lat);
    const checkout_long = Number(islatlng?.lng);
    if (isNaN(checkout_lat) || isNaN(checkout_long)) {
      alert(localization.locationPermission);
      return false;
    }
    const site = getSiteLatLng(siteData);
    let checkout_distance = 0;
    if (site) {
      checkout_distance = calcCrow(checkout_lat, checkout_long, site.lat, site.lng);
      if (!Number.isFinite(checkout_distance)) {
        toast.error('Distance Not Fetched.');
        return false;
      }
    }
    const payload = {
      id,
      checkout_lat,
      checkout_long,
      checkout_distance_in_km: checkout_distance,
      checkout_remark: '',
    };
    try {
      const res = await axios.post(`${Config.maintenance.rmCheckOut}`, payload);
      if (isCheckoutApiSuccess(res?.data)) {
        toast.success('Checkout Successfully.');
        if (typeof refreshAfterSiteCheckout === 'function') {
          await refreshAfterSiteCheckout(siteId, 'RM');
        }
        if (history) {
          history.push(`${baseUrl}/rm-tickets`);
        }
        return true;
      }
      toast.error(checkoutErrorMessage(res?.data));
    } catch (err) {
      toast.error(checkoutErrorMessage(err?.response?.data));
    }
    return false;
  }

  const checkOutButton = () => (
    isActiveDistanceCheckin(distanceDetails) ? (
      <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
        <div class="btn-group" role="group">
          <Button
            className=" btn btn-transparent btn-danger"
            onClick={() => handleCheckOut(resolveDistanceRowId(distanceDetails, activeDistanceCheckin))}
          >
            {localization.checkOut}
          </Button>
        </div>
      </div>
    ) : null
  );

  const headerBtns1 = () => {
    return (
      <Fragment>
        {checkOutButton()}
      </Fragment>
    );
  };

  const headerBtns = () => {
    return (
      <Fragment>
        {checkOutButton()}
        &nbsp;&nbsp;
        <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div class="btn-group" role="group">
          <Button
          className=" btn btn-transparent"
          onClick={() => setIsModal(true)}
        >
          {localization.changeStatus}
        </Button>
        
        <>
              <button id="btnGroupDrop1" type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Action
            </button>
            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <a class="dropdown-item" href={`/dashboard/mrf/rm/${match.params.id}/${
            rmTicketDetails.complains && rmTicketDetails.complains.site_id
          }`}>{localization.createMRF}</a>

              <a class="dropdown-item" href={`/dashboard/rm-assign-ticket/${match.params.id}`}>{localization.assignEngineer}</a>
            
            </div>
          </>
          </div>
        </div>
        {/* <Link
          to={`/dashboard/mrf/rm/${match.params.id}/${
            rmTicketDetails.complains && rmTicketDetails.complains.site_id
          }`}
          className="btn btn-primary"
        >
          {localization.createMRF}
          <img src={Images?.ArrowRight} alt=""></img>
        </Link> */}
        {/* <Link
          to={`/dashboard/rm-assign-ticket/${match.params.id}`}
          className="btn btn-primary"
        >
          {localization.assignEngineer}
          <img src={Images?.ArrowRight} alt=""></img>
        </Link> */}
      </Fragment>
    );
  };

  useEffect(() => {
    (async () => {
      if (fetchRmTicketDetails) {
        setIsLoading(true);
        await fetchRmTicketDetails(match.params.id);
        await fetchRmTicketStatus();
        setIsLoading(false);
      }
    })();
  }, [fetchRmTicketDetails]);

  const saveReply = async () => {
    if (remarkData.remarks !== '') {
      const res = await postRmRemark(remarkData);
      if (res === true) {
        setIsLoading(true);
        setSuccessModal(true);
        setIsLoading(true);
        await fetchRmTicketDetails(match.params.id);
        setIsLoading(false);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    (() => {
      if (successModal === true) {
        setRemarkData({
          rm_ticket_id: match.params.id,
          remarks: '',
          attachment: '',
        });
      }
    })();
  }, [successModal]);

  const updatePMStatus = async () => {
    const data = {
      rm_ticket_id: match.params.id,
      status: assigneeId,
    };
    if (assigneeId != '') {
      const res = await postUpdateRMStatus(data);
      if (res === true) {
        setIsModal(false);
        setIsLoading(true);
        await fetchRmTicketDetails(match.params.id);
        setIsLoading(false);
      }
    }
  };

  return (
    <Layout
      title={localization.ticketDetails}
      Buttons={!match.path.includes('rm-view/') ? (isRoleId.includes(9)) ? headerBtns1 : headerBtns : () => {}}
      isLoading={isLoading}
      isGoback
      linkUrl={
        match.path.includes('rm-view/')
          ? `${baseUrl}/approvals/rm-tickets`
          : `${baseUrl}/rm-tickets`
      }
    >
      {role === 9 && isOpen ?
          <div className="popup-box">
            <div className="box">
              <Link
                  to={`${baseUrl}/rm-tickets`}
                  className="btn btn-primary mb-4"
                  style={{'cursor': 'pointer','float':'right','border':'0px','box-shadow':'none !important','position':'relative','top':'-17px'}}
              >
                x
              </Link>
              {checkSiteIdSet && rmTicketDetails.complains?.site_id !== undefined ?
                    <DistanceCalculator
                        siteData={siteData}
                        getSiteData={getSiteData}
                        calculateDistance={calculateDistance}
                        siteId={rmTicketDetails.complains?.site_id !== undefined ? rmTicketDetails.complains?.site_id : "testing"}
                        moduleType={"RM"}
                    /> :
                  ""}
            </div>
          </div> :
      <>
          <CardSection title={localization.rmTicket}>
            <div className="details-listing">
              <DivLayout
                  heading={localization.ticketId}
                  data={rmTicketDetails.ticket && rmTicketDetails.ticket.ticket_id}
              />
              <DivLayout
                  heading={localization.createdOn}
                  data={
                      rmTicketDetails &&
                      rmTicketDetails.ticket &&
                      rmTicketDetails.ticket.created_on.slice(0, 10)
                  }
              />
              <DivLayout
                  heading={localization.raisedBy}
                  data={rmTicketDetails.ticket && rmTicketDetails.ticket.created_by}
              />
              <DivLayout
                  heading={localization.siteNumber}
                  data={rmTicketDetails.ticket && rmTicketDetails.ticket.site_no}
              />
              <DivLayout
                  heading={localization.siteName}
                  data={
                      rmTicketDetails.complains && rmTicketDetails.complains.site_name
                  }
              />
              <DivLayout
                  heading={localization.rmName}
                  data={rmTicketDetails.ticket && rmTicketDetails.ticket.rm_name}
              />
              <DivLayout
                  heading={localization.siteType}
                  data={rmTicketDetails.ticket && rmTicketDetails.ticket.site_type}
              />
              <DivLayout
                  heading={localization.liveDate}
                  data={rmTicketDetails.ticket && rmTicketDetails.ticket.live_date}
              />
              <DivLayout
                heading={localization.contractType}
                data={rmTicketDetails.ticket && rmTicketDetails.ticket.contract_type}
              />

              <DivLayout
                  heading={localization.gateNumber}
                  data={rmTicketDetails.ticket && rmTicketDetails.ticket.gate_no}
              />
              <DivLayout
                heading={localization.lastPmDate}
                data={rmTicketDetails.complains && rmTicketDetails.complains.last_pm_date}
              />
              <DivLayout
                heading={localization.lastPmAssignedTo}
                data={
                  rmTicketDetails.complains && rmTicketDetails.complains.pm_assigned_to_name 
                  ? `${rmTicketDetails.complains.pm_assigned_to_name} (${rmTicketDetails.complains.pm_assigned_to_email})`
                  : 'N/A'}
              />

              <DivLayout
                  heading={localization.assignedTo}
                  data={
                      rmTicketDetails.ticket &&
                      rmTicketDetails.ticket.assigned_to &&
                      rmTicketDetails.ticket.assigned_to.name
                  }
              />
              <DivLayout
                  heading={localization.status}
                  data={rmTicketDetails.ticket && rmTicketDetails.ticket.status}
              />


              {rmTicketDetails &&
                  rmTicketDetails.mrf_details &&
                  rmTicketDetails.mrf_details.length > 0 && (
                      <Fragment>
                        <h5 className="full-width">{localization.mrf}</h5>
                        <table className="panel-table faq-listing">
                          <thead>
                          <tr>
                            <th>{'MRF ID'}</th>
                            <th>{localization.createdOn}</th>
                            <th>{localization.plannedDeliveryDate}</th>
                            <th>{localization.status}</th>
                          </tr>
                          </thead>
                          <tbody>
                          {rmTicketDetails.mrf_details.map((obj, index) => {
                            return (
                                <tr key={index}>
                                  <td>
                                    <span className="th">{'MRF ID'}</span>
                                    {obj.mrf_id}
                                  </td>
                                  <td>
                                    <span className="th">{localization.createdOn}</span>
                                    {obj.created_at}
                                  </td>
                                  <td>
                            <span className="th">
                              {localization.plannedDeliveryDate}
                            </span>
                                    {obj.planned_delivery_date
                                        ? obj.planned_delivery_date
                                        : localization.na}
                                  </td>
                                  <td>
                                    <span className="th">{localization.status}</span>
                                    {obj.status}
                                  </td>
                                </tr>
                            );
                          })}
                          </tbody>
                        </table>
                      </Fragment>
                  )}

                  <div className="details-listing" style={{ padding: '20px' }}>
                  {rmTicketDetails &&
                          rmTicketDetails.amc_data &&
                          rmTicketDetails.amc_data.length > 0 && (
                            
                              <Fragment>
                                <h5 style={{ marginBottom: '20px' }} className="full-width">{"AMC Details"}</h5>
                                <table style={{ margin: '0 100 20px',tableLayout: 'fixed'}} className="panel-table faq-listing">
                                  <thead>
                                  <tr>
                                    <th>{'SNo.'}</th>
                                    <th style={{ margin: '0 0 20px'}}>{'Gate Name'}</th>
                                    <th>{'AMC Type'}</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                    
                                  {rmTicketDetails.amc_data.map((obj, index) => {
                                    return (
                                        <tr key={index}>
                                          <td>
                                            <span className="th">{'SNo.'}</span>
                                            {index+1}
                                          </td>
                                          <td>
                                            <span className="th">{'Gate Name'}</span>
                                            {obj.name}
                                          </td>
                                          <td>
                                            <span className="th">
                                              {'AMC Type'}
                                            </span>
                                            {obj.amc || 'N/A'}
                                          </td>
                                        </tr>
                                    );
                                  })}
                                  </tbody>
                                </table>
                              </Fragment>
                          )}
                  </div>
            </div>
          </CardSection>

           {/* rm-view-details */}
        {rmTicketDetails &&
          rmTicketDetails?.three_poc &&
          rmTicketDetails.three_poc.map((messageDatas, index) => ( 

              <CardSection 
                  title={`POC ${index + 1}`} 
              >
                  <div className="details-listing">
                      <DivLayout heading="Name" data={messageDatas.name} />
                      <DivLayout heading="Mobile Number" data={messageDatas.contact_no} />
                      <DivLayout heading="Email" data={messageDatas.email} />
                  </div>
              </CardSection>
        ))}
          
        <CardSection title={localization.complain}>
        <div className="details-listing">
        <DivLayout
        heading={localization.complainDescription}
        data={
        rmTicketDetails.complains &&
        formatDescription(rmTicketDetails?.complains?.complain_description)
        // parse(rmTicketDetails?.complains?.complain_description)
      }
        />
        <DivLayout
        heading={localization.complainType}
        data={
        rmTicketDetails.complains &&
        rmTicketDetails.complains.complain_type
      }
        />
        <DivLayout
        heading={`Type of Sale`}
        data={
        rmTicketDetails?.channelPartner &&
        rmTicketDetails?.channelPartner
      }
        />
        <DivLayout
        heading={localization.raisedBy}
        data={
        rmTicketDetails.complains &&
        rmTicketDetails.complains.complain_raised_by
      }
        />
        <DivLayout
        heading="Is Internet present"
        data={
        rmTicketDetails.complains &&
        rmTicketDetails.complains.is_internet
      }
        />
        <DivLayout
        heading="Call to client"
        data={
        rmTicketDetails.complains &&
        rmTicketDetails.complains.call_client
      }
        />

        <DivLayout
        heading={localization.gate}
        data={rmTicketDetails.complains && rmTicketDetails.complains.gate}
        />
         <DivLayout
        heading={localization.pocName}
        data={rmTicketDetails.complains && rmTicketDetails.complains.name_of_spoc}
        />
        <DivLayout
        heading={localization.phoneNumber}
        data={rmTicketDetails.complains && rmTicketDetails.complains.number_of_poc}
        />
        <DivLayout
        heading={localization.createdOn}
        data={rmTicketDetails?.complains?.created_at}
        />
      {/* <div className="details-list full-width">
              {(rmTicketDetails.complains.document) && (rmTicketDetails.complains.document.map((documents) => (
              <DocumentView attachment={documents} />
            )))}
          </div> */}
        </div>
        </CardSection>
      {rmTicketDetails.rm_close_data &&
        rmTicketDetails.rm_close_data.eng_remarks && (
        <CardSection title={localization.rmClosingDetails}>
        <div className="details-listing">
        <DivLayout
        heading={localization.delayDueTo}
        data={
        rmTicketDetails.rm_close_data.eng_remarks.delayed_due_to
      }
        />
        <DivLayout
        heading={localization.closedOn}
        data={
        rmTicketDetails.rm_close_data.eng_remarks.close_date
      }
        />
        <DivLayout
        heading={localization.closeReason}
        data={
        rmTicketDetails.rm_close_data.eng_remarks.reason_close
      }
        />
        <DivLayout
        heading={localization.remarkRunning}
        data={
        rmTicketDetails.rm_close_data.eng_remarks.remarks
      }
        />
        <DivLayout
        heading={localization.scopeOfCivilWork}
        data={
        rmTicketDetails.rm_close_data.eng_remarks.scope
      }
        />
        <DivLayout
        heading={localization.generalRemark}
        data={
        rmTicketDetails.rm_close_data.eng_remarks.gen_remarks
      }
        />
      {rmTicketDetails.rm_close_data.eng_remarks.document &&
        <DocumentView attachment={rmTicketDetails.rm_close_data.eng_remarks.document} />
      }

      {rmTicketDetails.rm_level_data && rmTicketDetails.rm_level_data.length > 0 &&
      <>
      {rmTicketDetails.rm_level_data.map((item, x) => 
      <>
       <hr/>
        <DivLayout
          heading="Equipment"
          data={
          item.equipment
        }
        />
        <DivLayout
          heading="Issue"
          data={
          item.issue
        }
        />
        <DivLayout
          heading="Component"
          data={
          item.componant
        }
        />
        {item.level_1 !== null &&
          <DivLayout
          heading="Level 1"
          data={
          item.level_1
          }
          />
        }
        {item.level_2 !== null &&
          <DivLayout
          heading="Level 2"
          data={
          item.level_2
          }
          />
        }
        {item.level_3 !== null &&
          <DivLayout
          heading="Level 3"
          data={
          item.level_3
          }
          />
        }
        {item.level_4 !== null &&
          <DivLayout
          heading="Level 4"
          data={
          item.level_4
          }
          />
        }
        {item.level_5 !== null &&
          <DivLayout
          heading="Level 5"
          data={
          item.level_5
          }
          />
        }
        <DivLayout
          heading="Remark"
          data={
          item.remark_val
        }
        />

      </>
      )}  
      </>  
      }
        </div>
        </CardSection>
        )
      }
      {rmTicketDetails.rm_close_data &&
        rmTicketDetails.rm_close_data.mh_remarks && (
        <CardSection title={localization.tktCompletionDetails}>
        <div className="details-listing">
        <DivLayout
        heading={localization.delayDueTo}
        data={
        rmTicketDetails.rm_close_data.mh_remarks.delayed_due_to
      }
        />
        <DivLayout
        heading={localization.closedOn}
        data={
        rmTicketDetails.rm_close_data.mh_remarks.close_date
      }
        />
        <DivLayout
        heading={localization.closeReason}
        data={
        rmTicketDetails.rm_close_data.mh_remarks.reason_close
      }
        />
        <DivLayout
        heading={localization.criticality}
        data={
        rmTicketDetails.rm_close_data.mh_remarks.criticality
      }
        />
        <DivLayout
        heading={localization.invoiceNo}
        data={
        rmTicketDetails.rm_close_data.mh_remarks.invoice_no
      }
        />
        <DivLayout
        heading='Material issued by store'
        data={
        rmTicketDetails.rm_close_data.mh_remarks.mat_issued_by_store
      }
        />
        <DivLayout
        heading='Old Actual Issue'
        data={
        rmTicketDetails.rm_close_data.mh_remarks.old_actual_issue
      }
        />
        <DivLayout
        heading='Report Signed By'
        data={
        rmTicketDetails.rm_close_data.mh_remarks.signed_by
      }
        />
        <DivLayout
        heading='Designation'
        data={
        rmTicketDetails.rm_close_data.mh_remarks.designation
      }
        />
        <DivLayout
        heading='Solution Provided/RCA'
        data={
        rmTicketDetails.rm_close_data.mh_remarks.solution
      }
        />
        <DivLayout
        heading='Type of Issue'
        data={
        rmTicketDetails.rm_close_data.mh_remarks.type_of_issue
      }
        />

        <DivLayout
        heading={localization.remarkRunning}
        data={
        rmTicketDetails.rm_close_data.mh_remarks.remarks
      }
        />
        <DivLayout
        heading={localization.scopeOfCivilWork}
        data={
        rmTicketDetails.rm_close_data.mh_remarks.scope
      }
        />
        </div>
        </CardSection>
        )
      }
      {rmTicketDetails.complains &&
        rmTicketDetails.complains.troubleshoot &&
        rmTicketDetails.complains.troubleshoot.length > 0 && (
        <div className="panel-card">
        <div className="panel-heading">{localization.troubleshoot}</div>
        <div className="panel-body">
        <div className="form-group">
        <div className="details-listing faq-listing">
      {rmTicketDetails.complains.troubleshoot &&
        rmTicketDetails.complains.troubleshoot.questions &&
        rmTicketDetails.complains.troubleshoot.questions.length &&
        rmTicketDetails.complains.troubleshoot.questions.map(
        (obj) => {
        return (
        <div className="details-list question-input">
        <label className="data-title">{obj.question}</label>
      {obj.answers.length &&
        obj.answers.map((ele, ind) => {
        return (
        <div className="sub-question" key={ind}>
        <label className="label">{ele.label}</label>
        <label className="label">
      {ele.answer}
        </label>
        </div>
        );
      })}
        </div>
        );
      }
        )}
        </div>
        </div>
        </div>
        </div>
        )}

      {rmTicketDetails.remarks && rmTicketDetails.remarks.length > 0 && (
        <CardSection title={localization.replies}>
        <div className="details-listing">
      {rmTicketDetails.remarks &&
        rmTicketDetails.remarks.length > 0 &&
        rmTicketDetails.remarks.map((obj) => {
        return (
        <div className="details-listing reply-box">
        <div className="details-byline">
        <div className="details-list">
        <strong className="data-title">
      {localization.replyDate}
        </strong>
        <span className="data-details">
      {obj?.created_at &&
        moment(obj.created_at).format(
        'DD-MM-YYYY HH:mm:ss'
        )}
        </span>
        </div>
        <div className="details-list">
        <strong className="data-title d-none d-md-block">
      {localization.repliedBy}
        </strong>
        <span className="data-details">
        <span className="d-md-none">By </span>
      {obj.replied_by}
        </span>
        </div>
        </div>
        <div className="details-list full-width">
        <DivLayout
        heading={localization.response}
        data={obj.remarks}
        />
        </div>
          <div className="details-list full-width">
            <DivLayout
                heading={localization.reason}
                data={obj.reason}
            />
          </div>
      {/* {obj.attachment && (
                      <div className="details-list full-width">
                        <DocumentView attachment={obj.attachment} />
                      </div>
                    )} */}
        <div className="details-list full-width">
      {obj.attachment && (obj.attachment.map((attachments) => (

        <DocumentView attachment={attachments} />

        )))}
        </div>
        </div>
        );
      })}
        </div>
        </CardSection>
        )}


{rmTicketDetails?.complains &&
        rmTicketDetails.complains?.messageData &&
        rmTicketDetails.complains.messageData.map((messageDatas) => ( 

            <PanelCardWithHeading title={`Replied By : `+messageDatas.message_from+` ( ` +messageDatas.created_at+ ` )`} colorChange={messageDatas.message_from == 'Client' && '#fff3f3'}>
              <div className="details-listing">
                <DivLayout heading={`Send To`} data={messageDatas.send_to} />
                {messageDatas.rm_ticket_id !== null && messageDatas.rm_ticket_id !='' ? (  
                  <DivLayout
                    heading={`Ticket Id`}
                    data={messageDatas.rm_ticket_id}
                  />
                ): 
                  <DivLayout
                    heading={`Created By`}
                    data={(messageDatas?.name !== null) ? messageDatas?.name : 'Client'}
                  />
                }
                {messageDatas?.document && (messageDatas.document.map((documentss) => (
                  <DocumentView attachment={documentss} />
                )))}
                <DivLayout
                  heading={`Message`}
                  data={messageDatas.message}
                />

                {messageDatas?.rm_ticket ? 
                <table className='panel-table table table-striped table-bordered'>
                  <thead>
                    <th>Assigned To</th>
                    <th>Status</th>
                    <th>Action</th>
                  </thead>
                  <tbody>
                  {messageDatas.rm_ticket && (messageDatas.rm_ticket.map((rmData) => (
                    
                      <tr>
                        <td>{rmData.assigned_to}</td>
                        <td>{rmData.status}</td>
                        <td><a class="btn btn-transparent" href={`/dashboard/rm-view/`+rmData.id}>View Details</a></td>
                        
                      </tr>
                    
                  )))}
                  </tbody>
                  </table>
                : null }
                
              </div>
            
              
          </PanelCardWithHeading>
        ))}

      {/*{rmTicketDetails.ticket && rmTicketDetails.ticket.status_code !== 5 && (
        <CardSection title={localization.reply}>
        <form>
        <div className="row">
        <div className="col-md-6 col-sm-12">
        <ConstantInput
        label={localization.enterReplyDescription}
        type="text"
        value={remarkData.remarks}
        handleChange={(val) =>
        setRemarkData({...remarkData, remarks: val})
      }
        />
        </div>
        <div className="col-md-6 col-sm-12">
        <FileUpload
        id="attactment"
        multiple="multiple"
        reset={successModal}
        accept=".pdf,.png,.jpg,.jpeg,.doc"
        documentUploadUrl={documentUploadUrl}
        onChange={(val) =>
        setRemarkData({...remarkData, attachment: val})
      }
        >
        <span className="btn btn-transparent">
      {localization.uploadMultiAttachment}
        </span>
        </FileUpload>
        </div>
          <div className="col-md-6 col-sm-12">
          <DropDownInput
              label={localization.reason}
              data={[{id:'Material Dependency', name:'Material Dependency'},
              {id:'Client Dependency', name:'Client Dependency'},
              {id:'Backend support required', name:'Backend support required'},
              {id:'Others', name:'Others'}
              ]}
              required
              isStarRequired={true}
              errorMsg={localization.isRequired}
              getIdValue={(val) => {
                setRemarkData({...remarkData, reason: val.id});
              }}
          />
          </div>
        </div>

        <div className="col-10">

        <button
        type="button"
        className="btn btn-primary"
        onClick={() => {
        saveReply();
      }}
        >
      {localization.reply} <img src={Images?.ArrowRight} alt="" />
        </button>
        </div>
        </form>
        </CardSection>
        )}*/}

        {/*<ModalPop
        title={localization.changeStatus}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
        >
        <div className="text-center">
        <h5>{localization.pleaseConfirmStatus}</h5>
        <DropDownInput
        label={localization.selectStatus}
        required
        isStarRequired={true}
        data={isRoleId.includes(9) ? [{id: 3, name: 'Closed'}] : rmStatus}
        errorMsg={localization.isRequired}
        getIdValue={(val) => setAssigneeId(val.id)}
        />
      {assigneeId == 3 || assigneeId == 5 ? (
        <a class="btn btn-primary" href={`/dashboard/rm-closed/${assigneeId}/${match.params.id}`}>{localization.continue}</a>
        ) : <Button
        className="btn btn-primary mb-4"
        onClick={() => updatePMStatus()}
        >
      {localization.continue} <img src={Images?.ArrowRight} alt="" />
        </Button>}

        </div>
        </ModalPop>*/}

        <ModalPop
        title={localization.conf}
        show={successModal}
        handleModalHide={() => {
        setSuccessModal(false);
      }}
        >
        <div className="text-center">
        <div className="success">
        <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.repliedSuccessfully}</h5>
        <Button
        onClick={() => {
        setSuccessModal(false);
      }}
        className="btn btn-primary mb-4"
        >
      {localization.continue} <img src={Images?.ArrowRight} alt="" />
        </Button>
        </div>
        </ModalPop>
      </>
      }
    </Layout>
  );
};

export default RmView;
